module.exports = "<svg width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" xmlns=\"http://www.w3.org/2000/svg\">\n  <title>\n    Artboard 3\n  </title>\n  <path d=\"M18 6.676V4S14.333 1 7 1v14c2.917 0 5.244.476 7 1.048V21c7.334 0 11-3 11-3V4s-2.338 1.903-7 2.676zM1 25h3V1H1v24z\" fill=\"#15100C\" fill-rule=\"evenodd\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./assets/svg/icon-26-attraction.svg
// module id = 3718
// module chunks = 168707334958949